/**
 * Generate a random UUID using native crypto API
 * Replaces uuid.v4() from the uuid library
 *
 * Browser support:
 * - Chrome 92+
 * - Firefox 95+
 * - Safari 15.4+
 * - Edge 92+
 *
 * @returns A random UUID string (e.g., "550e8400-e29b-41d4-a716-446655440000")
 */
export function generateUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for older browsers
  // This implements UUID v4 spec
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (char) => {
    const numericChar = parseInt(char, 10);
    const randomValue = crypto.getRandomValues(new Uint8Array(1))[0];

    // Perform the bitwise operations required for UUID v4 compliance
    return (numericChar ^ (randomValue & (15 >> (numericChar / 4)))).toString(
      16
    );
  });
}
